module.exports = "<ngx-ui-loader bgsSize=\"50\" bgsColor=\"#51cbce\" bgsOpacity=\"1\" bgsPosition=\"bottom-right\" bgsType=\"three-bounce\" ></ngx-ui-loader>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main